import { render, staticRenderFns } from "./tenderingfrm2.vue?vue&type=template&id=47de4ccd"
import script from "./tenderingfrm2.vue?vue&type=script&lang=js"
export * from "./tenderingfrm2.vue?vue&type=script&lang=js"
import style0 from "./tenderingfrm2.vue?vue&type=style&index=0&id=47de4ccd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports